import React from 'react';
import { Site } from '../../lib/Site';
import FooterLinksItem from '../FooterLinksMenu/FooterLinksItem';

interface Props {
    site: Site;
}

export default function ResourcesMenu({ site }: Props) {
    return (
        <div className="footer-links-menu">
            <ul className="footer-links-menu__items">
                <FooterLinksItem label={__('Become a designer')} url="/designers" />
                <FooterLinksItem label={__('Blog')} url="/blog/" />
                <FooterLinksItem label={'99awards'} url="/best-design-awards" />
                <FooterLinksItem label={__('Affiliates')} url="/affiliates" />
                <FooterLinksItem label={__('Logo ideas')} url="/inspiration/logos" />
                <FooterLinksItem label={__('T-shirt ideas')} url="/inspiration/t-shirt-designs" />
                <FooterLinksItem label={__('Designer resources')} url="/designer-resource-center" />
                {site.hasCapability('can_display_featured_partners_link') && (
                    <FooterLinksItem label={__('Featured partners')} url="/featured-partners" />
                )}
                <FooterLinksItem label={__('Help')} url="/help" />
            </ul>
        </div>
    );
}
